(() => {
  if (window.zhBlogConversionTrackingReady) return;
  window.zhBlogConversionTrackingReady = true;

  function prepareReaders(scope = document) {
    scope.querySelectorAll('[data-zh-reader]').forEach((reader) => {
      if (reader.dataset.readerReady) return;
      reader.dataset.readerReady = 'true';
      const headings = [...reader.querySelectorAll('[data-reader-body] h2')]
        .filter((heading) => heading.textContent.trim() && !heading.closest('nav'));
      if (headings.length < 3) return;
      const list = reader.querySelector('[data-reader-contents]');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `article-section-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      reader.querySelector('[data-reader-navigation]').hidden = false;
      reader.classList.add('zh-reader--with-navigation');
    });
  }
  prepareReaders();
  document.addEventListener('shopify:section:load', (event) => prepareReaders(event.target));

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-blog-conversion-link]');
    if (!link) return;

    const articleContext = link.closest('[data-article-id]');
    const blogContext = link.closest('[data-blog-portal]');
    const destinationUrl = new URL(link.href, window.location.origin);
    const detail = {
      event: 'blog_conversion_click',
      source_context: articleContext ? 'article' : blogContext ? 'blog_index' : 'blog',
      source_article_id: articleContext?.dataset.articleId || '',
      source_article_handle: articleContext?.dataset.articleHandle || '',
      source_blog_handle: articleContext?.dataset.blogHandle || blogContext?.dataset.blogHandle || '',
      destination_type: link.dataset.destinationType || 'link',
      destination_handle: link.dataset.destinationHandle || '',
      destination_host: link.dataset.destinationHost || destinationUrl.host,
      destination_path: destinationUrl.pathname
    };

    window.dispatchEvent(new CustomEvent('zhusrod:blog-conversion-click', { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
  });
})();
